/**
 * Downloads a blob as a file to the user's machine
 * @param blob - The blob data to download
 * @param filename - The filename for the downloaded file
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	window.URL.revokeObjectURL(url);
};
